import { OpenAPI } from '../../core/OpenAPI';
import { request } from '../../core/request';
import type { AsrProxyRetrieveTranscriptionResponseDto } from '../../models';

export class AsrProviderTranscriptService {
  static retrieveTranscription(provider: string, providerTranscriptId: string) {
    return request<AsrProxyRetrieveTranscriptionResponseDto>(OpenAPI, {
      method: 'GET',
      url: '/api/admin/asr-proxy/transcriptions/provider/{provider}/{providerTranscriptId}',
      path: { provider, providerTranscriptId },
    });
  }
}
